// extracted by mini-css-extract-plugin
module.exports = {"image":"skilent-module--image--2xno-","btn":"skilent-module--btn--33ob5"};